import { motion } from "framer-motion";
import { SectionHeader } from "@/components/SectionHeader";

const clients = [
  { name: "Zetwerk", image: "/assets/company/embedded-p3-3.jpeg", testId: "client-zetwerk-logo" },
  { name: "Sharp Tanks & Structurals - A Zetwerk Company", image: "/assets/company/embedded-p3-4.jpeg", testId: "client-sharp-tanks-logo" },
  { name: "OIL", text: true, testId: "client-oil-badge" },
];

export function Clients() {
  return (
    <section id="clients" className="border-b border-industrial-line bg-[#F1F1EC] py-24 sm:py-32" data-testid="clients-section">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <SectionHeader eyebrow="Clients / 06" title="Trusted by industrial leaders" description="Client relationships built through dependable project support, responsive coordination, and consistent execution." testId="clients-section-header" />
        <div className="grid gap-px border border-industrial-line bg-industrial-line sm:grid-cols-3" data-testid="trusted-clients-grid">
          {clients.map((client, index) => (
            <motion.div key={client.name} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }} className="group flex h-48 items-center justify-center bg-industrial-surface p-8 transition-colors hover:bg-[#EBEBE6]" data-testid={client.testId}>
              {client.text ? (
                <div className="text-center">
                  <p className="font-heading text-6xl font-bold uppercase tracking-tight text-industrial-text transition-colors group-hover:text-industrial-yellow">OIL</p>
                  <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.28em] text-industrial-muted">Trusted Client</p>
                </div>
              ) : (
                <img src={client.image} alt={`${client.name} logo`} loading="lazy" className="max-h-28 w-full object-contain transition-transform group-hover:-translate-y-1" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
